/* override functions api.jquery.js */
Shopify.onItemAdded = function (line_item) {
  Shopify.getCart(Shopify.onCartUpdate);
};

Shopify.onCartUpdate = function (cart) {
  console.log("onCartUpdate", cart);
  console.log("gift_var_id", gift_var_id);
  console.log("is_gwp_enabled", is_gwp_enabled);
  console.log("is_cart_page", is_cart_page);

  if (is_gwp_enabled) {
    // execute gwp feature and add free gift to cart
    var free_gift_id = gift_var_id;
    var line_items = cart.items;
    var free_product = line_items.filter(
      (item) => item.variant_id == gift_var_id
    );
    var cart_total = cart.total_price / 100;
    if (free_product.length == 0 && cart_total > gift_threshold) {
      console.log("Adding Free Gift");
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          id: free_gift_id,
          quantity: 1,
        },
        dataType: "json",
        success: function (data) {
          // fetching the latest cart
          $.ajax({
            type: "GET",
            url: "/cart.js",
            dataType: "json",
            success: function (data) {
              console.log("CART: ", data);
              Shopify.cartUpdateInfo(data, ".single-cart-item-loop");
            },
            error: function (err) {
              console.log("Onerror: ", err);
            },
          });
        },
        error: function (err) {
          console.log("Onerror: ", err);
        },
      });
    } else {
      Shopify.cartUpdateInfo(cart, ".single-cart-item-loop");
    }
    if (free_product.length != 0 && cart_total <= gift_threshold) {
      console.log("Removing Free Gift");
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: {
          id: free_gift_id,
          quantity: 0,
        },
        dataType: "json",
        success: function (data) {
          //         Shopify.cartUpdateInfo(cart, '.single-cart-item-loop');
          // fetching the latest cart
          $.ajax({
            type: "GET",
            url: "/cart.js",
            dataType: "json",
            success: function (data) {
              console.log("CART: ", data);
              Shopify.cartUpdateInfo(data, ".single-cart-item-loop");
            },
            error: function (err) {
              console.log("Onerror: ", err);
            },
          });
        },
        error: function (err) {
          console.log("Onerror: ", err);
        },
      });
    } else {
      Shopify.cartUpdateInfo(cart, ".single-cart-item-loop");
    }
    // execute gwp feature and add free gift to cart
  } else {
    // execute normal cart flow
    Shopify.cartUpdateInfo(cart, ".single-cart-item-loop");
    // execute normal cart flow
  }
};

Shopify.onError = function (XMLHttpRequest, textStatus) {
  var data = eval("(" + XMLHttpRequest.responseText + ")");
  if (!!data.message) {
    var str = data.description;
  } else {
    var str =
      "Error : " + Shopify.fullMessagesFromErrors(data).join("; ") + ".";
  }
  jQuery(".error_message").text(str);
  jQuery("#modalAddToCartError").modal("toggle");
  setTimeout(function () {
    jQuery(".shopping__cart").removeClass("shopping__cart__on");
    jQuery(".body__overlay").removeClass("is-visible");
  }, 2000);
};

Shopify.addItem = function (variant_id, quantity, callback) {
  console.log("addItem funtion");
  var quantity = quantity || 1;
  var params = {
    type: "POST",
    url: "/cart/add.js",
    data: "quantity=" + quantity + "&id=" + variant_id,
    dataType: "json",
    success: function (line_item) {
      if (typeof callback === "function") {
        callback(line_item);
      } else {
        Shopify.cartPopap(variant_id);
        Shopify.onItemAdded(line_item);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    },
  };
  jQuery.ajax(params);
};

Shopify.addItemFromForm = function (form_id, variant_id, callback) {
  var params = {
    type: "POST",
    url: "/cart/add.js",
    beforeSend: function () {
      if (form_id == "add-item-qv") {
        jQuery("#" + form_id)
          .find(".addtocartqv")
          .html(jQuery(".quickViewModal_info .button_wait").html());
      }
    },
    data: jQuery("#" + form_id).serialize(),
    dataType: "json",
    success: function (line_item) {
      console.log("in function:Shopify.addItemFromForm");
      console.log("line_item:: ", line_item);
      if (typeof callback === "function") {
        callback(line_item);
      } else {
        if (form_id != "add-item-qv") {
          Shopify.cartPopapForm(variant_id);
        } else {
          jQuery("#" + form_id)
            .find(".addtocartqv")
            .html(jQuery(".quickViewModal_info .button_added").html());
          jQuery("#" + form_id)
            .find(".addtocartqv")
            .addClass("added_in_cart");
          setTimeout(function () {
            jQuery("#" + form_id)
              .find(".addtocartqv")
              .removeClass("added_in_cart");
            jQuery("#" + form_id)
              .find(".addtocartqv")
              .html(jQuery(".quickViewModal_info .button").html());
          }, 2000);
        }
        Shopify.onItemAdded(line_item);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      if (form_id != "add-item-qv") {
        Shopify.onError(XMLHttpRequest, textStatus);
      } else {
        jQuery("#" + form_id)
          .find(".addtocartqv")
          .html(jQuery(".quickViewModal_info .button_error").html());
        jQuery("#" + form_id)
          .find(".addtocartqv")
          .addClass("error_in_cart");
        setTimeout(function () {
          jQuery("#" + form_id)
            .find(".addtocartqv")
            .removeClass("error_in_cart");
          jQuery("#" + form_id)
            .find(".addtocartqv")
            .html(jQuery(".quickViewModal_info .button").html());
        }, 2000);
      }
      Shopify.onItemAdded(line_item);
    },
  };
  jQuery.ajax(params);
};

/* user functions */

Shopify.addItemFromFormStart = function (form, product_id) {
  Shopify.addItemFromForm(form, product_id);
};

Shopify.cartPopap = function (variant_id) {
  var image = jQuery("." + variant_id + ":first .popup_cart_image").attr("src");
  var title = jQuery("." + variant_id + ":first .popup_cart_title").text();
  // var propPrice = jQuery('#product_current_price').text();
  jQuery(".popupimage").attr("src", "" + image + "");
  jQuery(".productmsg").text("" + title + "");
  //jQuery('.pop_current_price').text('"'+ propPrice +'"');
  jQuery("#modalAddToCart").modal("toggle");
};
Shopify.cartPopapForm = function (variant_id) {
  var image = jQuery(".product_variant_image").attr("src");
  var title = jQuery("#popup_cart_title").text();
  jQuery(".popupimage").attr("src", "" + image + "");
  jQuery(".productmsg").text('"' + title + '"');
  jQuery("#modalAddToCart").modal("toggle");
};

Shopify.cartUpdateInfo = function (cart, cart_cell_id) {
  //   console.log("Latest Cart: ",cart);
  $("#mini-cart-checkout").attr("href", "");
  var formatMoney = window.money_format;
  if (typeof cart_cell_id === "string") {
    var cart_cell = jQuery(cart_cell_id);
    if (cart_cell.length) {
      cart_cell.empty();

      jQuery.each(cart, function (key, value) {
        if (key === "items") {
          if (value.length) {
            jQuery(
              ".single-product-cart, .item-multiple-item-count,.minicart-content-box"
            ).css({ display: "block" });

            jQuery(".single-cart-product.empty , .item-single-item-count").css({
              display: "none",
            });

            $(".minicart_heading").html(
              `<p>Your Cart (${cart.item_count})</p>`
            );

            var table = jQuery(cart_cell_id);
            //console.log('this is item object -->',value)
            var cell_total = jQuery(".minicart-button");
            jQuery.each(value, function (i, item) {
              console.log("this is item object -->", item);
              if (i > 19) {
                return false;
              }
              if (item.price == 0) {
                console.log("first condition called !!");
                //`Rs ${ item.variant.compare_at_price }`
                //`Rs ${item.final_price}`
                jQuery(
                  `
				  <li class="minicart-item">
				  <div class="minicart-thumb">
				  <a href="${item.url}">
				  <img src="${item.image}" class="img-fluid" alt="">
				  </a>
				  </div>
				  <div class="minicart-content">
				  <h3 class="product-name">
				  <a href="${item.url}">${item.title}</a>
				  </h3>
                  <div style="display:flex;justify-content: flex-start; align-items: center;">
                    <p class="price-strike">` +
                    Shopify.formatMoney(item.price, +formatMoney) +
                    `</p>
                  <span class="cart-price discounted-price">` +
                    Shopify.formatMoney(item.discounted_price, +formatMoney) +
                    `</span>                      
                </div>
                  </div>
				  <a class="minicart-remove" href="javascript:void(0);" onclick="Shopify.removeItem(${item.variant_id})">
				  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                   <path d="M1.75 3.5H2.91667H12.25" stroke="#A8A8A8" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                   <path d="M4.66602 3.49935V2.33268C4.66602 2.02326 4.78893 1.72652 5.00772 1.50772C5.22652 1.28893 5.52326 1.16602 5.83268 1.16602H8.16602C8.47543 1.16602 8.77218 1.28893 8.99097 1.50772C9.20977 1.72652 9.33268 2.02326 9.33268 2.33268V3.49935M11.0827 3.49935V11.666C11.0827 11.9754 10.9598 12.2722 10.741 12.491C10.5222 12.7098 10.2254 12.8327 9.91602 12.8327H4.08268C3.77326 12.8327 3.47652 12.7098 3.25772 12.491C3.03893 12.2722 2.91602 11.9754 2.91602 11.666V3.49935H11.0827Z" stroke="#A8A8A8" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                 </svg>
				  </a>
				  </li>
              `
                ).appendTo(table);
                //           <p>
                // <span class="cart-price discounted-price">`+Shopify.formatMoney(item.price,+ formatMoney)+`</span></p>
              } else if (item.discounted_price != item.price) {
                console.log("second condition called !!");
                console.log(
                  "condition checking.... for final price -->",
                  item.final_price
                );
                console.log(
                  "condition checking.... for actual price -->",
                  item.price
                );
                jQuery(
                  `
				  <li class="minicart-item">
				  <div class="minicart-thumb">
				  <a href="${item.url}">
				  <img src="${item.image}" class="img-fluid" alt="">
				  </a>
				  </div>
				  <div class="minicart-content">
				  <h3 class="product-name">
				  <a href="${item.url}">${item.title}</a>
				  </h3>
				  <div style="display:flex;justify-content: flex-start; align-items: center;">
                    <p class="price-strike">Rs ${item.price / 100}</p>
                  <span class="cart-price discounted-price">Rs ${
                    item.discounted_price / 100
                  }</span>                      
                </div>
			<div class="item_qty_wrap">
				<div class="pro-quantity">  
				  <div class="product-details-cart">
					<div class="quantity">
					  <div class="product-quantity-action quantity-selector pro-qty-cart">
					 <span data-count="minicart_input_${i}" class="dec qtybtn_minicart" onlick="` +
                    changeItemQty() +
                    `">-</span>
                     <input data-variant-id="${item.variant_id}" id="minicart_input_${i}" type="text" value="${item.quantity}" name="updates[]" class="cart-plus-minus-box" />
                     <span data-count="minicart_input_${i}" class="inc qtybtn_minicart" onlick="` +
                    changeItemQty() +
                    `">+</span>
					  </div>
					</div>
				  </div>
				</div>
			  </div>
                  </div>
				  <a class="minicart-remove" href="javascript:void(0);" onclick="Shopify.removeItem(${item.variant_id})">
				  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                   <path d="M1.75 3.5H2.91667H12.25" stroke="#A8A8A8" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                   <path d="M4.66602 3.49935V2.33268C4.66602 2.02326 4.78893 1.72652 5.00772 1.50772C5.22652 1.28893 5.52326 1.16602 5.83268 1.16602H8.16602C8.47543 1.16602 8.77218 1.28893 8.99097 1.50772C9.20977 1.72652 9.33268 2.02326 9.33268 2.33268V3.49935M11.0827 3.49935V11.666C11.0827 11.9754 10.9598 12.2722 10.741 12.491C10.5222 12.7098 10.2254 12.8327 9.91602 12.8327H4.08268C3.77326 12.8327 3.47652 12.7098 3.25772 12.491C3.03893 12.2722 2.91602 11.9754 2.91602 11.666V3.49935H11.0827Z" stroke="#A8A8A8" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                 </svg>
				  </a>
				  </li>
              `
                ).appendTo(table);
              } else {
                console.log("last condition called !!");
                console.log(
                  "condition checking.... for final price -->",
                  item.final_price
                );
                console.log(
                  "condition checking.... for actual price -->",
                  item.price
                );
                //,+ formatMoney
                jQuery(
                  `
				  <li class="minicart-item">
				  <div class="minicart-thumb">
				  <a href="${item.url}">
				  <img src="${item.image}" class="img-fluid" alt="">
				  </a>
				  </div>
				  <div class="minicart-content">
				  <h3 class="product-name">
				  <a href="${item.url}">${item.title}</a>
				  </h3>
				  <div style="display:flex;justify-content: flex-start; align-items: center;">
                  <span class="cart-price discounted-price">` +
                    Shopify.formatMoney(item.price).replace("$", "Rs ") +
                    `</span>                      
                </div>
			<div class="item_qty_wrap">
				<div class="pro-quantity">  
				  <div class="product-details-cart">
					<div class="quantity">
					  <div class="product-quantity-action quantity-selector pro-qty-cart">
					 <span data-count="minicart_input_${i}" class="dec qtybtn_minicart" onlick="` +
                    changeItemQty() +
                    `">-</span>
                     <input data-variant-id="${item.variant_id}" id="minicart_input_${i}" type="text" value="${item.quantity}" name="updates[]" class="cart-plus-minus-box" />
                     <span data-count="minicart_input_${i}" class="inc qtybtn_minicart" onlick="` +
                    changeItemQty() +
                    `">+</span>
					  </div>
					</div>
				  </div>
				</div>
			  </div>
                  </div>
				  <a class="minicart-remove" href="javascript:void(0);" onclick="Shopify.removeItem(${item.variant_id})">
				  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                   <path d="M1.75 3.5H2.91667H12.25" stroke="#A8A8A8" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                   <path d="M4.66602 3.49935V2.33268C4.66602 2.02326 4.78893 1.72652 5.00772 1.50772C5.22652 1.28893 5.52326 1.16602 5.83268 1.16602H8.16602C8.47543 1.16602 8.77218 1.28893 8.99097 1.50772C9.20977 1.72652 9.33268 2.02326 9.33268 2.33268V3.49935M11.0827 3.49935V11.666C11.0827 11.9754 10.9598 12.2722 10.741 12.491C10.5222 12.7098 10.2254 12.8327 9.91602 12.8327H4.08268C3.77326 12.8327 3.47652 12.7098 3.25772 12.491C3.03893 12.2722 2.91602 11.9754 2.91602 11.666V3.49935H11.0827Z" stroke="#A8A8A8" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                 </svg>
				  </a>
				  </li>
              `
                ).appendTo(table);
              }
            });
          } else {
            jQuery(
              ".single-product-cart, .item-single-item-count,.minicart-content-box"
            ).css({ display: "none" });
            jQuery(".single-cart-product.empty").css({ display: "block" });
          }
        }
      });

      if (cart.total_price > 400000) {
        jQuery(".free-gift-banners").html(
          `<img src="https://cdn.shopify.com/s/files/1/0548/8286/1165/files/Frame_4_8e2aab2e-c9ea-416f-9163-e81a7ba65b72.png?v=1673078242" alt="image" />`
        );
      } else {
        jQuery(".free-gift-banners").html(``);
      }

      //<span>Click Checkout to Avail Free Gift 🎁</span>
      if (cart.total_discount / 100 != 0) {
        jQuery(".minicart-button").html(`
   <div class='total-tally'>
      <span>Yay! 🎊🎉 You saved an extra Rs. ${cart.total_discount / 100}</span>
   </div>
   <button type="button" id="checkout2"  onclick="handleFloCheckoutBtn()" class="btn btn_checkout" name="checkout2" 
              style="color: #fff;
                    font-size: 13px;
                    display: block;
                    font-weight: 500;
                    line-height: 1;
                    padding: 17px 0;
                    background: #00313C;
                    text-transform: uppercase;
                    border-radius: 2px;
                    text-align: center;
                    width: 100%;">
		<pre style="display: flex;
                    justify-content: center;
                    overflow: hidden;
                    background: transparent;
                    padding: 0;
                    margin: auto;
                    font-family: 'Rubik';
                    font-style: normal;
                    font-weight: 600;
                    font-size: 16px;
                    line-height: 19px;
                    color: #FFFFFF;">Checkout   •  <p class='price-strike'>Rs ${
                      cart.original_total_price / 100
                    }</p>• Rs. ${cart.total_price / 100}</pre>
            </button>`);
        jQuery(".minicart_heading").html(
          `
<p>Your Cart (` +
            cart.item_count +
            `)</p>
      `
        );
      } else {
        jQuery(".minicart-button").html(`
   <button type="button" id="checkout2"  onclick="handleFloCheckoutBtn()" class="btn btn_checkout" name="checkout2" 
              style="color: #fff;
                    font-size: 13px;
                    display: block;
                    font-weight: 500;
                    line-height: 1;
                    padding: 17px 0;
                    background: #00313C;
                    text-transform: uppercase;
                    border-radius: 2px;
                    text-align: center;
                    width: 100%;">
		<pre style="display: flex;
                    justify-content: center;
                    overflow: hidden;
                    background: transparent;
                    padding: 0;
                    margin: auto;
                    font-family: 'Rubik';
                    font-style: normal;
                    font-weight: 600;
                    font-size: 16px;
                    line-height: 19px;
                    color: #FFFFFF;">Checkout   •  Rs. ${
                      cart.total_price / 100
                    }</pre>
            </button>`);
        jQuery(".minicart_heading").html(
          `
<p>Your Cart (` +
            cart.item_count +
            `)</p>
      `
        );
      }

      //       $('.single-cart-product').css({{}})
    }
  }

  changeHtmlValue(
    ".shopping-cart__total",
    Shopify.formatMoney(cart.total_price, formatMoney)
  );
  changeHtmlValue(".bigcounter", cart.item_count);
  if (cart.item_count > 0) {
    jQuery(".bigcounter").addClass("Glow_number");
  } else {
    jQuery(".bigcounter").removeClass("Glow_number");
  }

  jQuery(".currency .active").trigger("click");

  // Open cart drawer on add-to-cart in bothe mobile and desktop
  setTimeout(function () {
    if (is_cart_page) {
      console.log(is_cart_page);
    } else {
      console.log(is_cart_page);
      $(".minicart-btn").click();
    }
  }, 1000);
};

//Utils
function changeHtmlValue(cell, value) {
  var $cartLinkText = jQuery(cell);
  $cartLinkText.html(value);
}

function IsFreeGiftPresent(cart) {
  console.log("IsFreeGiftPresent", cart);
  console.log("gift_var_id", gift_var_id);
  console.log("is_gwp_enabled", is_gwp_enabled);
  console.log("gift_threshold", gift_threshold);
  var free_product_variant_id = gift_var_id;
  var line_items = cart.items;
  var free_product = line_items.filter(
    (item) => item.variant_id == gift_var_id
  );
  var cart_total = cart.total_price / 100;
  //   console.log("free_product: ",free_product);
  if (free_product.length == 0 && cart_total > gift_threshold) {
    return true;
  } else {
    return false;
  }
}

function changeItemQty() {
  console.log("changeItemQty: ");
}

$(document).on("click", ".qtybtn_minicart", function () {
  var newVal = 0;
  var $button = $(this);
  var dataVal = $(this).attr("data-count");
  var oldValue = $(`#${dataVal}`).val();
  var var_id = 0;
  var_id = $(`input#${dataVal}`).attr("data-variant-id");
  var quantity = newVal;
  console.log(var_id, ":", quantity);
  //         alert(oldValue);
  //       console.log(dataVal,':',oldValue);
  if ($button.hasClass("inc")) {
    newVal = parseFloat(oldValue) + 1;
    quantity = newVal;
    //         Shopify.addItem(var_id,quantity,Shopify.onItemAdded);
  } else {
    // Don't allow decrementing below zero
    if (oldValue > 0) {
      newVal = parseFloat(oldValue) - 1;
      quantity = newVal;
    } else {
      newVal = 0;
      quantity = newVal;
    }
  }
  $(`input#${dataVal}`).attr("value", newVal);
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      id: var_id,
      quantity: quantity,
    },
    dataType: "json",
    success: function (data) {
      //         Shopify.cartUpdateInfo(cart, '.single-cart-item-loop');
      // fetching the latest cart
      $.ajax({
        type: "GET",
        url: "/cart.js",
        dataType: "json",
        success: function (data) {
          //               console.log("CART: ",data)
          console.log("fetching the latest cart");
          Shopify.onCartUpdate(data);
          //               Shopify.cartUpdateInfo(data, '.single-cart-item-loop');
        },
        error: function (err) {
          console.log("Onerror: ", err);
        },
      });
    },
    error: function (err) {
      console.log("Onerror: ", err);
    },
  });
});

function updateCartPageData(cart, cell_id) {
  console.log(cell_id);
  $("div#pre_loader").css({ display: "block" });
  setTimeout(function () {
    window.location.href = window.location.href;
  }, 1000);
}
